import React, { useState } from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { IInputProps } from 'utils/types/common';
import DisplayPassword from './DisplayPassword';

const InputPassword: React.FC<IInputProps> = ({
  register,
  errors,
  title,
  name,
  placeHolder,
  type = 'text',
  errText = 'error',
  opts,
  disabled = false,
}) => {
  const err = Object.keys(errors)
    .filter((item) => item === name)
    .toString();

  const [showPass, setShowPass] = useState<boolean>(false);

  return (
    <InputWrapper>
      <TextWrapper className={`${err && 'text-red'}`}>{title}</TextWrapper>
      <PasswordWrapper>
        <Input
          disabled={disabled}
          type={showPass ? 'text' : 'password'}
          min='0'
          placeholder={placeHolder}
          className={`${err ? 'border-red' : ''}`}
          {...register(name, opts)}
        />
        <DisplayPasswordWrapper>
          <DisplayPassword isShow={showPass} setShowPass={setShowPass} />
        </DisplayPasswordWrapper>
      </PasswordWrapper>
    </InputWrapper>
  );
};

export default InputPassword;

const InputWrapper = styled.div`
  position: relative;
  .border-red {
    border: 1px solid ${theme.colors.redText};
  }
  .border-red {
    border: 1px solid ${theme.colors.redText};
  }
  .text-red {
    color: ${theme.colors.redText};
  }
`;

const PasswordWrapper = styled.div`
  position: relative;
`;

const Input = styled.input`
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid ${theme.colors.gray_7};
  width: 100%;
  height: 40px;

  &:disabled {
    background-color: #e1e1e1;
    cursor: not-allowed;
  }
`;

const TextWrapper = styled.p`
  color: ${theme.colors.dark_500};
  font-size: ${theme.fontSizes.sm};
  margin-bottom: 8px;
`;

const DisplayPasswordWrapper = styled.div`
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
`;
